export enum Language {    
    English = 0,
    Arabic = 1,
    Chinese = 2,
    French = 3,
    German = 4,
    Korean = 5,
    Russian = 6,
    Spanish = 7,
    Tagalog = 8,
    Vietnamese = 9,
    Other = 999
}